export const breakpoints = {
  xl: 2500,
  lg: 1200,
  md: 1000,
  sm: 768,
  xs: 480
};
export const colWidth = { xl: 12, lg: 10, md: 8, sm: 6, xs: 4 };
